SET_MESSAGE_BOX_VISIBLE